import { useFlickity } from '@/components/hooks/useFlickity'
import { BaseResults } from 'libs/searchspring/components/recommendations/BaseResults'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useState, useEffect } from 'preact/hooks'
import clsx from 'clsx'

export function CarouselResults({
  className,
  wrapperClassName = '',
  options = { pageDots: true, cellAlign: 'left' },
  productCardSettings,
  'data-dl-section-id': dataDlSectionId
}) {
  const { results, isLoading } = useSearchspringContext()
  const [skeletonNode, setSkeletonNode] = useState()
  const [realNode, setRealNode] = useState()
  const [containerNode, setContainerNode] = useState()
  const [showRealCarousel, setShowRealCarousel] = useState(false)

  useFlickity(skeletonNode, options, [])
  const { SliderPortal, flickity } = useFlickity(realNode, options, [results])

  const hasData = !isLoading && results?.results

  useEffect(() => {
    if (hasData && flickity && containerNode) {
      const skeletonHeight = containerNode.getBoundingClientRect().height
      containerNode.style.height = `${skeletonHeight}px`

      flickity.resize()
      flickity.reloadCells()

      const timer = setTimeout(() => {
        containerNode.style.height = ''
        setShowRealCarousel(true)
      }, 100)

      return () => clearTimeout(timer)
    } else {
      setShowRealCarousel(false)
    }
  }, [hasData, flickity, containerNode])

  return (
    <BaseResults
      className={className}
      wrapperClassName={wrapperClassName}
      productCardSettings={productCardSettings}
      renderWrapper={(skeletonItems, realItems) => (
        <div ref={setContainerNode} className="relative grid w-full grid-cols-1 grid-rows-1 transition-all">
          <div
            className={clsx(
              'col-start-1 row-start-1 w-full transition-opacity',
              !showRealCarousel ? 'opacity-100' : 'pointer-events-none h-0 opacity-0'
            )}
          >
            <div ref={setSkeletonNode} className={clsx('flex w-full', options.pageDots && 'pb-1.5 lg:pb-1.625')}>
              {skeletonItems}
            </div>
          </div>

          <div
            className={clsx(
              'col-start-1 row-start-1 w-full transition-opacity',
              showRealCarousel ? 'opacity-100' : 'pointer-events-none opacity-0'
            )}
          >
            <div
              ref={setRealNode}
              className={clsx('flex w-full', options.pageDots && 'pb-1.5 lg:pb-1.625')}
              data-dl-section-id={dataDlSectionId}
            >
              <SliderPortal>{realItems}</SliderPortal>
            </div>
          </div>
        </div>
      )}
    />
  )
}
